import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["dwell"]
  static values = { dwell: Number }
  connect() {} 

  toggle(e) {
    e.preventDefault();
    Array.from(document.querySelectorAll("[data-camdwell-target]")).forEach( e => { e.classList.remove('bold') })
    this.refresh(document.querySelector("#matched_dwell"))
  }  

  refresh(field) {
    if (field.value == this.dwellValue) {
      field.value = "-1"
      this.dwellTarget.classList.remove("bold")
    }
    else {
      field.value = this.dwellValue
      this.dwellTarget.classList.add("bold")
    }

    field.closest('form').dispatchEvent(new Event('input'))
  } 
}
